import Search from '../shared/searchFormLitepicker.vue'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector("#vueSearchformDateRange");
  const data = el.dataset;
  const app = new Vue({
    el,
    render(h){
      return h(Search, {
        props: {
            title: JSON.parse(data.title),
            loc: data.loc,
            wknd: data.wknd,
            params:  JSON.parse(data.params),
            region: data.region,
            page: data.page
        }
      });
    }
  });
});